import React from 'react';
import { Container, Typography, Link, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const Impressum = () => {
  const navigate = useNavigate();

  return (
    <>
        <Button variant="contained" color="primary" onClick={() => navigate('/')}>
        Zurück zur Startseite
      </Button>
      <Container sx={{ mt: 6, pt: 3, pb: 3 }}>
        <Typography variant="h4" gutterBottom>Impressum</Typography>
      </Container>

      <Container className="container_impressum">
        <Typography variant="h5">Dienstanbieter</Typography>
        <Typography paragraph>
          Nikolai Samusew Clean Life<br />
          Gebäude & Garten Management<br />
          Pfalzgrafenstraße 26<br />
          67061 Ludwigshafen am Rhein
        </Typography>

        <Typography variant="h5">Kontakt</Typography>
        <Typography paragraph>
          Telefon: <Link href="tel:017631339183">0176 313 39 183</Link><br />
          E-Mail: <Link href="mailto:info@samusew-clean-life.de">info@samusew-clean-life.de</Link>
        </Typography>

        <Typography variant="h5">Angaben zur Berufshaftpflichtversicherung</Typography>
        <Typography paragraph>
          <strong>Name und Sitz des Versicherers:</strong><br />
          Nürnberger Versicherung<br />
          Marthastraße 16 90482 Nürnberg
        </Typography>

        <Typography variant="h5">Verbraucherstreitbeilegung/Universalschlichtungsstelle</Typography>
        <Typography paragraph>
          Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
        </Typography>

        <Typography variant="h5">
          Zentrale Kontaktstelle nach dem Digital Services Act - DSA (Verordnung (EU) 2022/265)
        </Typography>
        <Typography paragraph>
          Unsere zentrale Kontaktstelle für Nutzer und Behörden nach Art. 11, 12 DSA erreichen Sie wie folgt:
        </Typography>
        <Typography paragraph>
          E-Mail: <Link href="mailto:info@samusew-clean-life.de">info@samusew-clean-life.de</Link><br />
          Telefon: <Link href="tel:017631339183">0176 313 39 183</Link>
        </Typography>
        <Typography paragraph>
          Die für den Kontakt zur Verfügung stehenden Sprachen sind: Deutsch, Englisch, Deutsch und Englisch.
        </Typography>
      </Container>

      <Container sx={{ pt: 3, pb: 3 }}>
        <Typography variant="h4" gutterBottom>Datenschutzerklärung</Typography>
      </Container>

      <Container className="container_impressum">
        <Typography variant="h5">1. Datenschutz auf einen Blick</Typography>
        <Typography variant="h6">Allgemeine Hinweise</Typography>
        <Typography paragraph>
          Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten passiert, wenn Sie diese Website besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können.
        </Typography>
        <Typography variant="h6">Datenerfassung auf dieser Website</Typography>
        <Typography variant="subtitle1">Wer ist verantwortlich für die Datenerfassung auf dieser Website?</Typography>
        <Typography paragraph>
          Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. Dessen Kontaktdaten finden Sie im Abschnitt "Hinweis zur verantwortlichen Stelle".
        </Typography>
        <Typography variant="subtitle1">Wie erfassen wir Ihre Daten?</Typography>
        <Typography paragraph>
          Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen – z.B. Daten, die Sie in ein Kontaktformular eingeben. Andere Daten werden automatisch beim Besuch der Website durch unsere IT-Systeme erfasst (z.B. Browser, Betriebssystem, Uhrzeit).
        </Typography>
        <Typography variant="subtitle1">Wofür nutzen wir Ihre Daten?</Typography>
        <Typography paragraph>
          Ein Teil der Daten wird erhoben, um eine fehlerfreie Bereitstellung der Website zu gewährleisten. Andere können zur Analyse Ihres Nutzerverhaltens verwendet werden.
        </Typography>
        <Typography variant="subtitle1">Welche Rechte haben Sie bezüglich Ihrer Daten?</Typography>
        <Typography paragraph>
          Sie haben jederzeit das Recht auf unentgeltliche Auskunft über Herkunft, Empfänger und Zweck Ihrer gespeicherten personenbezogenen Daten. Außerdem das Recht auf Berichtigung oder Löschung, Widerruf erteilter Einwilligungen und Beschwerderecht bei der zuständigen Aufsichtsbehörde.
        </Typography>

        <Typography variant="h6">Analyse-Tools und Tools von Drittanbietern</Typography>
        <Typography paragraph>
          Beim Besuch dieser Website kann Ihr Surf-Verhalten statistisch ausgewertet werden. Das geschieht mit sogenannten Analyseprogrammen. Detaillierte Informationen dazu finden Sie im weiteren Verlauf der Datenschutzerklärung.
        </Typography>

        <Typography variant="h5">2. Hosting</Typography>
        <Typography paragraph>
          Wir hosten die Inhalte unserer Website bei folgendem Anbieter:
        </Typography>
        <Typography variant="h6">Strato</Typography>
        <Typography paragraph>
          Anbieter ist die Strato AG, Otto-Ostrowski-Straße 7, 10249 Berlin. Beim Besuch dieser Website erfasst Strato verschiedene Logfiles inklusive Ihrer IP-Adresse.
        </Typography>
        <Typography paragraph>
          Weitere Infos: <Link href="https://www.strato.de/datenschutz/" target="_blank" rel="noopener noreferrer">strato.de/datenschutz</Link>
        </Typography>

        <Typography variant="subtitle1">Auftragsverarbeitung</Typography>
        <Typography paragraph>
          Wir haben einen Vertrag über Auftragsverarbeitung (AVV) abgeschlossen. Dieser gewährleistet, dass Strato personenbezogene Daten nur nach unseren Weisungen und unter Einhaltung der DSGVO verarbeitet.
        </Typography>

        <Typography variant="h5">3. Allgemeine Hinweise und Pflichtinformationen</Typography>
        <Typography variant="h6">Datenschutz</Typography>
        <Typography paragraph>
          Wir behandeln Ihre personenbezogenen Daten vertraulich und entsprechend den gesetzlichen Datenschutzvorschriften sowie dieser Datenschutzerklärung.
        </Typography>
        <Typography paragraph>
          Wir weisen darauf hin, dass die Datenübertragung im Internet Sicherheitslücken aufweisen kann. Ein lückenloser Schutz ist nicht möglich.
        </Typography>

        <Typography variant="h6">Hinweis zur verantwortlichen Stelle</Typography>
        <Typography paragraph>
          Verantwortlich:
          <br />Nikolai Samusew<br />
          Pfalzgrafenstraße 26<br />
          67061 Ludwigshafen am Rhein<br />
          Telefon: <Link href="tel:017631339183">0176 313 39 183</Link><br />
          E-Mail: <Link href="mailto:info@samusew-clean-life.de">info@samusew-clean-life.de</Link>
        </Typography>
        <Typography paragraph>
          Die verantwortliche Stelle entscheidet allein oder gemeinsam mit anderen über die Zwecke und Mittel der Verarbeitung von personenbezogenen Daten.
        </Typography>

        <Typography variant="h6">Speicherdauer</Typography>
        <Typography paragraph>
          Soweit innerhalb dieser Datenschutzerklärung keine speziellere Speicherdauer genannt wurde, verbleiben Ihre personenbezogenen Daten bei uns, bis der Zweck für die Datenverarbeitung entfällt.
        </Typography>

        <Typography variant="h6">Widerruf Ihrer Einwilligung zur Datenverarbeitung</Typography>
        <Typography paragraph>
          Sie können eine bereits erteilte Einwilligung jederzeit widerrufen. Die Rechtmäßigkeit der bis zum Widerruf erfolgten Datenverarbeitung bleibt unberührt.
        </Typography>

        <Typography variant="h6">Widerspruchsrecht gegen die Datenerhebung in besonderen Fällen sowie gegen Direktwerbung (Art. 21 DSGVO)</Typography>
        <Typography paragraph>
          Sie haben jederzeit das Recht, aus Gründen, die sich aus Ihrer besonderen Situation ergeben, gegen die Verarbeitung Ihrer personenbezogenen Daten Widerspruch einzulegen.
        </Typography>

        <Typography variant="h6">Beschwerderecht bei der zuständigen Aufsichtsbehörde</Typography>
        <Typography paragraph>
          Im Falle von DSGVO-Verstößen steht Ihnen ein Beschwerderecht bei der Aufsichtsbehörde Ihres Wohnsitzes, Arbeitsplatzes oder des Orts des mutmaßlichen Verstoßes zu.
        </Typography>

        <Typography variant="h6">Recht auf Datenübertragbarkeit</Typography>
        <Typography paragraph>
          Sie haben das Recht, Daten, die wir auf Grundlage Ihrer Einwilligung oder in Erfüllung eines Vertrags automatisiert verarbeiten, an sich oder an Dritte aushändigen zu lassen.
        </Typography>

        <Typography variant="h6">SSL- bzw. TLS-Verschlüsselung</Typography>
        <Typography paragraph>
          Diese Seite nutzt aus Sicherheitsgründen eine SSL-/TLS-Verschlüsselung. Eine verschlüsselte Verbindung erkennen Sie am "https://" und dem Schloss-Symbol in Ihrer Browserzeile.
        </Typography>

        <Typography variant="h5">4. Datenerfassung auf dieser Website</Typography>
        <Typography variant="h6">Einwilligung mit Usercentrics</Typography>
        <Typography paragraph>
          Diese Website nutzt Usercentrics zur Einholung von Cookie-Einwilligungen. Anbieter: Usercentrics GmbH, Sendlinger Straße 7, 80331 München. Website: <Link href="https://usercentrics.com/de/" target="_blank" rel="noopener noreferrer">usercentrics.com</Link>
        </Typography>

        <Typography variant="h5">5. Plugins und Tools</Typography>
        <Typography variant="h6">Google Fonts (lokales Hosting)</Typography>
        <Typography paragraph>
          Diese Seite nutzt Google Fonts lokal. Es findet keine Verbindung zu Google-Servern statt. Mehr Informationen: <Link href="https://developers.google.com/fonts/faq" target="_blank" rel="noopener noreferrer">developers.google.com/fonts/faq</Link>
        </Typography>

        <Typography variant="h6">Google Maps</Typography>
        <Typography paragraph>
          Diese Seite nutzt Google Maps. Anbieter: Google Ireland Limited, Gordon House, Barrow Street, Dublin 4, Irland. Ihre IP-Adresse wird ggf. an Google in die USA übertragen. Details: <Link href="https://policies.google.com/privacy?hl=de" target="_blank" rel="noopener noreferrer">policies.google.com/privacy</Link>
        </Typography>

        <Typography paragraph>
          Google ist zertifiziert unter dem "EU-US Data Privacy Framework". Details: <Link href="https://www.dataprivacyframework.gov/" target="_blank" rel="noopener noreferrer">Data Privacy Framework</Link>
        </Typography>
      </Container>

      <Button variant="contained" color="primary" onClick={() => navigate('/')}>
        Zurück zur Startseite
      </Button>
    </>
  );
};

export default Impressum;
